export class ClearCacheService {
    static clearCache(Origin, Files, ByType, MethodType) {
        return fetch('https://akamai-cache-invalidation-api.arkadiumhosted.com/api/akamai/cache/invalidate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic b0771dd5-7d82-411b-a1ff-73ca32555f9b',
            },
            body: JSON.stringify({ Origin, Files, ByType, MethodType }),
        });
    }

    static clearCacheByItems(Items, ByType, MethodType) {
        return fetch('https://akamai-cache-invalidation-api.arkadiumhosted.com/api/akamai/cache/invalidate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic b0771dd5-7d82-411b-a1ff-73ca32555f9b',
            },
            body: JSON.stringify({ Items, ByType, MethodType }),
        });
    }

    static clearCacheRedirects() {
        const containerName = (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? 'arenaxstorage-blob' : 'arenaxstoragedev-blob';
        const files = [`${containerName}/arenax-global-settings/redirects/redirects.json`];
        const origin = 'arenacloud.cdn.arkadiumhosted.com';
        ClearCacheService.clearCache(origin, files, 'Url', 'Delete');
    }

    static clearByArkFiles() {
        if (process.env.NODE_ENV !== 'live' && process.env.NODE_ENV !== 'feature-live') {
            return;
        }
        const files = [
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_de.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en-au.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en-ca.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en-gb.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en-nz.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en-us.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_en.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_es.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_fr.json',
            '/arenaxstorage-blob/arenax-game-feeds-content/ArkCom_Prod_it.json',
            '/arenaxstorage-blob/arkcom-games-sorting-analytics/arkadium.com_auto.json',
            '/arenaxstorage-blob/arkcom-games-whynottrythese-analytics/arkadium.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/ark-connected-apps/arkadium-connected-apps.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/ark-homepage-games/game-lists.prod.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/ark-homepage-games/game-lists-redesign.prod.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/ark-games-sorted-by-game-starts/ark-games-sorted-by-game-starts.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/arkcom-iframe-games/iframe-games-list.json',
            '/arenax-index/_arena-shared-content_/arkcom-abtests/arena-data-abtest.json',
            '/arenax-index/_arena-shared-content_/ark-pages-seo/categories-seo.production.json',
            '/arenax-index/_arena-shared-content_/ark-pages-seo/non-categories-seo.production.json',
            '/arenax-index/_arena-shared-content_/ark-pages-seo/non-categories-seo.production.json',
            '/arenax-index/_arena-shared-content_/ark-pages-seo/co-branded-pages-seo.production.json',
            '/overwrites-arkadiumcom-live/iframe-rendering.html',
        ];

        return ClearCacheService.clearCache('arenacloud.cdn.arkadiumhosted.com', files, 'Url', 'Delete')
            .then((res) => {
                console.log('cleared cache by files');
            })
            .catch((_) => {
                console.log(_);
            });
    }

    static clearBannerMessages() {
        const origin = 'arenacloud.cdn.arkadiumhosted.com';
        const containerName = (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? 'arenaxstorage-blob' : 'arenaxstoragedev-blob';
        const filePath = `/${containerName}/arenax-index/_arena-shared-content_/arena-banners/banner-messages.json`;
        return ClearCacheService.clearCache(origin, [filePath], 'Url', 'Delete')
            .then(() => console.log('cleared cache for banner-messages.json'))
            .catch((e) => console.error('Failed to clear cache for banner-messages.json', e));
    }

    static clearEventCategoryConfig() {
        const origin = 'arenacloud.cdn.arkadiumhosted.com';
        const containerName = (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? 'arenaxstorage-blob' : 'arenaxstoragedev-blob';
        const filePath = `/${containerName}/arenax-index/_arena-shared-content_/ark-event-category/custom-categories-config.json`;
        return ClearCacheService.clearCache(origin, [filePath], 'Url', 'Delete')
            .then(() => console.log('cleared cache for custom-categories-config.json'))
            .catch((e) => console.error('Failed to clear cache for custom-categories-config.json', e));
    }

    /** Dev + live blob paths for syndication client-config.json on CDN */
    static clearSyndicationClientConfigCache() {
        const origin = 'arenacloud.cdn.arkadiumhosted.com';
        const files = [
            '/arenaxstoragedev-blob/arenax-index/_arena-shared-content_/syndication2/client-config.json',
            '/arenaxstorage-blob/arenax-index/_arena-shared-content_/syndication2/client-config.json',
        ];
        return ClearCacheService.clearCache(origin, files, 'Url', 'Delete')
            .then(() => console.log('cleared CDN cache for syndication2/client-config.json (dev + live)'))
            .catch((e) => console.error('Failed to clear syndication client-config CDN cache', e));
    }
}
